import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';
import {
  TimingPair,
  timingPairStringify,
} from '@faire/web/common/timings/TimingMarker';

export const eventKey = 'signup-time_from_email_to_button-timing';

/**
 * Time taken between email input and email submit on Sign Up modal
 */
export function trackSignupTimeFromEmailToButtonTiming(
  timingParameterToken: TimingPair
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      timingParameterToken: timingPairStringify(timingParameterToken) ?? '',
    },
  });
}
